import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
// import { ASSETS_BASE_URL } from "../../../config/constants";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { usePermissions } from "../../../controllers/PermissionContext";
import { formatProjectDate } from "../../../controllers/common";
import moment from "moment";
const CampaignOrderDetails = () => {
  const PERMISSION = usePermissions("campaignOrder");
  const location = useLocation();
  const state = location.state; // Data passed from the previous page
  const [orderData, setOrderData] = useState(state ?? {});
  const navigate = useNavigate();
  const targetRef = useRef(null);
  const [showPin, setShowPin] = useState(false);
  const togglePinShow = () => {
    setShowPin(!showPin);
    setTimeout(()=>{
      setShowPin(false);
    },3000);
  }
  useEffect(() => {
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
    if(PERMISSION && (PERMISSION?.fullAccess === 'Y' || PERMISSION?.view === 'Y')){
    } else{
      navigate('/dashboard');
    }
    document.title = "Crown-King || Order Details";
  }, []);

  return (
    <div ref={targetRef}>
      <div className="container-fluid">
        <div className="orders_main_contaniner">
          <div>
            <nav className="navbar navbar-light justify-content-between w-100 navbar_content">
              <Link to="/order/list" className="navbar-brand common_inventory_heading">
                Order Details
              </Link>
              <Link to="/campaign/order/list">
                <button type="button" className="btn btn-secondary">
                  <ArrowLeftOutlined /> Back
                </button>
              </Link>
            </nav>
          </div>

          {/* Order Summary Section */}
          <div className="order_now_card_title"></div>
          <div className="row mt-4">
            <div className="col-lg-8">
              <div className="card mb-4">
                <div className="card-body">
                  <p><strong>Order Number :</strong> {orderData?.order_no}</p>
                  <p><strong>Status :</strong> {orderData?.status}</p>
                  <p><strong>Order Date :</strong> {formatProjectDate(orderData?.createdAt)}</p>
                  <p><strong>Total Quantity :</strong> {orderData?.total_qty}</p>
                  <p><strong>Commission Percentage :</strong> {orderData?.commission_percentage}%</p>
                  <p><strong>Draw Date :</strong> {formatProjectDate(orderData?.draw_date_time)}</p>
                  {showPin ?(
                    <p><strong>Pin :</strong> {orderData?.pin} </p>
                  ):(
                    <p><strong>Pin :</strong> **** 
                      {PERMISSION?.fullAccess === 'Y' && (<FontAwesomeIcon icon={faEye} onClick={togglePinShow} />)}
                    </p>
                  )}
                </div>
              </div>

              {/* Straight Details */}
              {orderData?.straight?.qty > 0 && (
                <div className="card mb-4">
                  <div className="card-body">
                    <span className="orders_now_billing_details_heading">Straight Details</span>
                      <p><strong>Points :</strong> {orderData?.straight?.points || 0}</p>
                      <p><strong>Quantity :</strong> {orderData?.straight?.qty || 0}</p>
                      <p><strong>Total Points :</strong> {orderData?.straight?.total_points || 0}</p>
                  </div>
                </div>
              )}

              {/* Rumble Details */}
              {orderData?.rumble?.qty > 0 && (
                <div className="card mb-4">
                  <div className="card-body">
                    <span className="orders_now_billing_details_heading">Rumble Details</span>
                    <p><strong>Points :</strong> {orderData?.rumble?.points || 0}</p>
                    <p><strong>Quantity :</strong> {orderData?.rumble?.qty || 0}</p>
                    <p><strong>Total Points :</strong> {orderData?.rumble?.total_points || 0}</p>
                  </div>
                </div>
              )}

              {/* Chance Details */}
              {orderData?.chance?.qty > 0 && (
                <div className="card mb-4">
                  <div className="card-body">
                    <span className="orders_now_billing_details_heading">Chance Details</span>
                      <p><strong>Points :</strong> {orderData?.chance?.points || 0}</p>
                      <p><strong>Quantity :</strong> {orderData?.chance?.qty || 0}</p>
                      <p><strong>Total Points :</strong> {orderData?.chance?.total_points || 0}</p>
                  </div>
                </div>
              )}

              {( (PERMISSION?.fullAccess === 'Y' || PERMISSION?.coupon === 'Y') && orderData?.ticket?.length > 0) && (
                <div className="card mb-4">
                  <div className="card-body">
                    <span className="orders_now_billing_details_heading">Tickets Details</span>
                    {orderData?.ticket?.map((items, index) => (<>
                      <p key={index}><strong>Coupon Code :</strong> {items?.ticket || 'N/A'} || Type : {items?.type || "N/A"}</p>
                      <hr/>    
                    </>))}
                  </div>
                </div>
              )}
            </div>

            {/* Buyer and Seller Details */}
            <div className="col-lg-4">
              <div className="card mb-4">
                <div className="card-body">
                  <span className="orders_now_billing_details_heading">Billing Summary</span>
                  <p><strong>Total Points :</strong> {orderData?.total_points || 0}</p>
                  <p><strong>Discount :</strong> {orderData?.discount || "0"}</p>
                  <p><strong>Sub Total :</strong> {orderData?.total_points || 0}</p>
                </div>
              </div>
              <div className="card mb-4">
                <div className="card-body">
                  <span className="orders_now_billing_details_heading">Seller Details</span>
                  <p>
                    <strong>Name:</strong> {orderData?.seller_first_name} {orderData?.seller_last_name}
                  </p>
                  <p><strong>Mobile :</strong> {orderData?.seller_mobile}</p>
                  <p><strong>POS Number :</strong> {orderData?.seller_pos_number}</p>
                  <p><strong>Serial No. :</strong> {orderData?.seller_user_id?.pos_serial_id}</p>
                  <p><strong>App Version :</strong> {orderData?.version || ""}</p>
                </div>
              </div>
              <div className="card mb-4">
                <div className="card-body">
                  <span className="orders_now_billing_details_heading">Buyer Details</span>
                  <p>
                    <strong>Name :</strong> {orderData?.bind_person_name || "N/A"}
                  </p>
                  <p><strong>Mobile :</strong> {orderData?.bind_person_mobile || "N/A"}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignOrderDetails;
